/**
 * Adds dynamic tags for special characters in strings.
 * Converts `[text]` patterns to highlighted spans.
 *
 * Lives in this zero-dep leaf (rather than resource-list-item) so both resource-list-item AND
 * resource-codex-meta-components can import it from a normal package barrel without the two packages
 * forming an import/chunk cycle.
 */
export function addDynamicTags(string = "") {
  if (!string) return ""

  const regex = /\[([^\]]+)\]/g

  return string.replace?.(
    regex,
    `<span class="text-highlight px-1 py-0.5 rounded">$1</span>`
  )
}
